import { render, staticRenderFns } from "./AddWineryRow.vue?vue&type=template&id=13491b2d"
import script from "./AddWineryRow.vue?vue&type=script&lang=js"
export * from "./AddWineryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports